// extracted by mini-css-extract-plugin
module.exports = {"block":"VitalModal_block__6O7o1","saveBtn":"VitalModal_saveBtn__prO_1","units":"VitalModal_units___gT9x","note":"VitalModal_note__mdXhb"};